import Api from "../../../../util/Api";

export default function getInitState() {
    return {
        gridIsShow: true,
        formIsShow: false,
        expenditureForm: false,

        eBeutaloTableAdditionalConfig: {
            initOnRender: false
        },
        eBeutaloActions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            },
            {
                btn_text: '<i class="fas fa-plus"></i> Új beutaló',
                event_name: "customClick",
                class: "btn btn-success my-custom-class",
                event_payload: 'newEbeutalo'
            }
        ],
        eBeutaloEkatActions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            }
        ],
        eBeutaloEKatRowActions: [
            {
                btn_text: '<i class="fas fa-arrow-right"></i>',
                title: 'Kiválasztás',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'selectEBeu'
            },
        ],
        eBeutaloRowActions: [
            {
                btn_text: '<i class="far fa-folder-open"></i>',
                title: 'Megtekintés',
                event_name: "customClick",
                class: "btn btn-outline-success",
                event_payload: 'showDetails'
            },
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteBeutaloConfirm'
            },
            {
                btn_text: '<i class="fas fa-edit"></i>',
                title: 'Beutaló felhasználásának rögzítése',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'showBeutaloForm'
            },
        ],
        eBeutaloFormActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning my-custom-class mx-1",
                event_payload: 'backToGrid'
            }
        ],
        eBeutaloSearchFields: [
            {
                name: "betegIdTipus",
                label: "Páciens azonosítás típus",
                formSize: 4,
                formType: "select",
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getIdTypeList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "betegIdErtek",
                label: "Páciens azonosító",
                formSize: 4,
                formType: "text"
            },
            {
                label: "Szolgáltatás típus",
                name: "szolgaltatasTipus",
                formSize: 4,
                formType: 'select',
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getSzakmaKodList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                label: "Beutaló állapot",
                name: "beutaloAllapot",
                formSize: 4,
                formType: 'select',
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getBeutaloAllapotList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                label: "Keresési szcenárió",
                name: "keresesiSzcenarioKod",
                formSize: 4,
                formType: 'select',
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getKeresesScenarioList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                label: "Beutaló időszak kezdete",
                name: "beutaloIdoszakKezdete",
                formSize: 4,
                formType: 'date'
            },
            {
                label: "Beutaló időszak vége",
                name: "beutaloIdoszakVege",
                formSize: 4,
                formType: 'date'
            },
            {
                label: "Ellátási időszak kezdete",
                name: "ellatasIdoszakKezdete",
                formSize: 4,
                formType: 'date'
            },
            {
                label: "Ellátási időszak vége",
                name: "ellatasIdoszakVege",
                formSize: 4,
                formType: 'date'
            },
            {
                name: "breakGlass",
                label: "Sürgősségi adatlekérés",
                description: "Sürgős lekérdezés esetén indoklás szükséges!",
                formSize: 4,
                formType: 'checkbox'
            },
            {
                name: "breakGlassOk",
                label: "Sürgős lekérdezés indoklás",
                formSize: 4,
                formType: 'text'
            }
        ],
        eBeutaloTableHeaderFields: [
            {
                name: "beutaloAzonosito",
                label: "Beutaló azonosítója",
                visibility: false,
                viewModalShow: true
            },
            {
                name: "rogzitesIdeje",
                label: "Rögzítés ideje",
                filter: {
                    type: "simple",
                },
                slot_name: "datetime_format",
                sort: true,
                visibility: true,
                formType: "dateTime",
                viewModalShow: true
            },
            {
                name: "kiallitasDatuma",
                label: "Kiállítás dátuma",
                filter: {
                    type: "simple",
                },
                slot_name: "created_on_format",
                sort: true,
                visibility: false,
                formType: "date",
                viewModalShow: true
            },
            {
                name: "ervenytessegDatuma",
                label: "Érvényesség dátuma",
                filter: {
                    type: "simple",
                },
                slot_name: "appointment_format",
                sort: true,
                visibility: true,
                formType: "date",
                viewModalShow: true
            },
            {
                name: "beutaloTipus",
                label: "Típus",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: true,
                viewModalShow: true
            },
            {
                name: "beutaloAllapot",
                label: "Állapot",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: true,
                viewModalShow: true
            },
            {
                name: "szakmaiAdatok.beutaloOka",
                label: "Beutaló oka",
                filter: {
                    type: "simple",
                },
                sort: true,
                visibility: true,
                viewModalShow: true
            },
            {
                name: "betegErtesites",
                label: "Beteg értesítés?",
                visibility: false,
                formType: "checkbox",
                viewModalShow: true
            },
            {
                name: "orvosErtesites",
                label: "Orvos értesítés?",
                visibility: false,
                formType: "checkbox",
                viewModalShow: true
            },
            {
                name: "papiralapu",
                label: "Papíralapú?",
                visibility: false,
                formType: "checkbox",
                viewModalShow: true
            },
            {
                name: "surgossegiBeutalo",
                label: "Sürgősségi beutaló?",
                visibility: false,
                formType: "checkbox",
                viewModalShow: true
            },
            {
                name: "beutaloIntezmeny.intezmenyMegnevezes",
                label: "Beutaló intézmény",
                visibility: false,
                viewModalShow: true
            },
            {
                name: "beutaloIntezmeny.szervezetiEgysegMegnevezes",
                label: "Beutaló szervezeti egység",
                visibility: false,
                viewModalShow: true
            },
            {
                name: "ellatoIntezmeny.intezmenyMegnevezes",
                label: "Ellátó intézmény",
                visibility: false,
                viewModalShow: true
            },
            {
                name: "ellatoIntezmeny.szervezetiEgysegMegnevezes",
                label: "Ellátó szervezeti egység",
                visibility: false,
                viewModalShow: true
            },
            {
                name: "beutaloOrvosName",
                label: "Beutaló orvos",
                visibility: false,
                slot_name: "beutaloOrvos_format",
                viewModalShow: true
            },
            {
                name: "szakmaiAdatok.betegsegFenallasIdeje",
                label: "Betegség fennálás ideje",
                visibility: false,
                viewModalShow: true
            },
            {
                name: "szakmaiAdatok.beutaloDiagnozis",
                label: "Beutaló diagnózis",
                visibility: false,
                viewModalShow: true
            },
            {
                name: "szakmaiAdatok.beutaloDiagnozisLeiras",
                label: "Diangózis leírás",
                visibility: false,
                viewModalShow: true
            },
            {
                name: "szakmaiAdatok.beutaloNaploSorszam",
                label: "Beutaló naplósorszáma",
                visibility: false,
                viewModalShow: true
            },
            {
                name: "szakmaiAdatok.beutaloSzoveg",
                label: "Szöveg",
                visibility: false,
                viewModalShow: true
            },
            {
                name: "szakmaiAdatok.keresoKeptelensegMiattSoronKivul",
                label: "Keresőképtelenség miatti soron kívüli ellátás",
                visibility: false,
                formType: "checkbox",
                viewModalShow: true
            },
            {
                name: "szakmaiAdatok.korelozmeny",
                label: "Kórelőzmény",
                visibility: false,
                viewModalShow: true
            },
            {
                name: "szakmaiAdatok.koziliumKerdes",
                label: "Konzíliumi kérdés",
                visibility: false,
                viewModalShow: true
            },
            {
                name: "szakmaiAdatok.szolgaltatasTipus",
                label: "Szolgáltatás típus",
                visibility: false,
                viewModalShow: true
            },
            {
                name: "szakmaiAdatok.teruletiEllatasiKozelettsegFennall",
                label: "Területi ellátási kötelezettségen kívül",
                visibility: false,
                formType: "checkbox",
                viewModalShow: true
            },
            {
                name: "szakmaiAdatok.utazasiKoltsegTeritesTipus",
                label: "Utazási költségttérítés",
                visibility: false,
                viewModalShow: true
            },
            {
                name: "utolsoAllapotValtozasIdeje",
                label: "Utolsó állapot változás ideje",
                visibility: false,
                slot_name: "modified_on_format",
                formType: "dateTime",
                viewModalShow: true
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ],
        eBeutaloHeaderFields: [
            {
                name: "patientId",
                label: "Páciens azonosító",
                visibility: false,
                formVisible: false
            },
            {
                name: "doctorId",
                label: "Beutaló orvos",
                visibility: false,
                formVisible: true,
                formRequired: true,
                formSize: 2,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getAllDoctor,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "beutaloIntezmenyTipus",
                label: "Beutaló intézmény típusa",
                visibility: false,
                formVisible: true,
                formRequired: true,
                formSize: 2,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getBeutaloIntezmenyTipusList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "beutaloIntezmenyFinanszirozasiKod",
                label: "Beutaló intézmény finanszírozási kódja",
                visibility: false,
                formVisible: true,
                formSize: 2,
                formType: "text",
            },
            {
                name: "rowBreak",
                label: "rowBreak",
                rowBreak: true,
                formSize: 6,
                visibility: false,
                formVisible: true
            },
            {
                name: "kiallitasDatuma",
                label: "Kiállítás dátuma",
                visibility: false,
                formVisible: true,
                formRequired: true,
                formSize: 2,
                formType: "date",
            },
            {
                name: "ervenytessegDatuma",
                label: "Érvényesség dátuma",
                visibility: false,
                formVisible: true,
                formRequired: true,
                formSize: 2,
                formType: "date",
            },
            {
                name: "beutaloNaploSorszam",
                label: "Beutaló naplószorszáma",
                visibility: false,
                formVisible: true,
                formReadOnly: true,
                formRequired: true,
                formSize: 2,
                formType: "text",
            },
            {
                name: "tappenzesNaploSzam",
                label: "Táppénzes naplószám",
                visibility: false,
                formVisible: true,
                formSize: 2,
                formType: "text",
            },
            {
                name: "beutaloTipus",
                label: "Beutaló típusa",
                visibility: false,
                formVisible: true,
                formRequired: true,
                formSize: 2,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getBeutaloTipusaList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "beutaloOka",
                label: "Beutaló oka",
                visibility: false,
                formVisible: true,
                formRequired: true,
                formSize: 2,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getBeutalasOkaList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "utazasiKoltsegTeritesTipus",
                label: "Utazási költségttérítés",
                visibility: false,
                formVisible: true,
                formRequired: true,
                formSize: 2,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getUtazasKoltsegteritesList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "utazasiUtalvanySzama",
                label: "Utazási költségtérítés utalványszám",
                visibility: false,
                formVisible: true,
                formSize: 2,
                formType: "text",
            },
            {
                name: "betegsegFenallasIdeje",
                label: "Betegség fennállásának ideje (nap)",
                visibility: false,
                formVisible: true,
                formRequired: true,
                formSize: 2,
                formType: "number",
            },
            {
                name: "keresoKeptelensegMiattSoronKivul",
                label: "Keresőképtelenség miatti soron kívüli ellátás",
                visibility: false,
                formVisible: true,
                formRequired: true,
                formSize: 2,
                formType: "checkbox",
            },
            {
                name: "surgossegiBeutalo",
                label: "Sürgősségi beutaló",
                visibility: false,
                formVisible: true,
                formRequired: true,
                formSize: 2,
                formType: "checkbox",
            },
            {
                name: "rowBreak2",
                label: "rowBreak2",
                rowBreak: true,
                formSize: 2,
                visibility: false,
                formVisible: true
            },
            {
                name: "szolgaltatasTipus",
                label: "Szolgáltatás típusa",
                visibility: false,
                formVisible: true,
                formRequired: true,
                formSize: 2,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getSzakmaKodList,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "ellatoIntezmenyIntezmenyKod",
                label: "Ellátó intézmény kódja",
                visibility: false,
                formVisible: false,
                formRequired: true,
                formSize: 2,
                formType: "text",
            },
            {
                name: "ellatoIntezmenyIntezmenyMegnevezes",
                label: "Ellátó intézmény",
                visibility: false,
                formVisible: false,
                formSize: 3,
                formType: "text",
            },
            {
                name: "ellatoIntezmenyIntezmeny",
                label: "Ellátó intézmény",
                visibility: false,
                formVisible: true,
                formRequired: true,
                formSize: 3,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getEuSzolg,
                    formatText: function (val) {
                        return val.kozpontitorzsnev;
                    },
                    formatOption: function (val) {
                        return val.kozpontitorzsnev;
                    },
                    searchOnServer: true,
                    minimumInputLength: 3,
                    filteredAttr: 'kozpontitorzsnev',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "ellatoIntezmenySzervezetiEgysegKod",
                label: "Ellátó intézmény szervezeti egység kódja",
                visibility: false,
                formVisible: false,
                formRequired: true,
                formSize: 2,
                formType: "text",
            },
            {
                name: "ellatoIntezmenySzervezetiEgysegMegnevezes",
                label: "Ellátó intézmény szervezeti egység",
                visibility: false,
                formVisible: false,
                formSize: 3,
                formType: "text",
            },
            {
                name: "ellatoIntezmenySzervezetiEgyseg",
                label: "Ellátó intézmény",
                visibility: false,
                formVisible: true,
                formRequired: true,
                formSize: 3,
                formType: "select",
                selectOptions: {
                    apiCallback: Api.getEuSzolgEngedely,
                    additionalApiCallbackParams: {
                        euszolgAzonosito: '-1'
                    },
                    formatText: function (val) {
                        return val.szervezetiegysegnev;
                    },
                    formatOption: function (val) {
                        return val.szervezetiegysegnev + " (" + val.szakmaNev + ")";
                    },
                    filteredAttr: 'szervezetiegysegnev',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            /*{
                name: "teruletiEllatasiKozelettsegFennall",
                label: "Területi ellátási kötelezettségen kívül",
                visibility: false,
                formVisible: true,
                formRequired: true,
                formSize: 3,
                formType: "checkbox",
            },*/
            {
                name: "beutaloDiagnozis",
                label: "Beutaló BNO kód",
                visibility: false,
                formVisible: true,
                formRequired: true,
                formSize: 6,
                formType: "selectBNOSingle",
                selectOptions: {
                    formatText: function (val) {
                        return val.leiras;
                    },
                    returnValue: "kod"
                }
            },
            {
                name: "rowBreak3",
                label: "rowBreak3",
                rowBreak: true,
                formSize: 6,
                visibility: false,
                formVisible: true
            },
            {
                name: "beutaloDiagnozisLeiras",
                label: "Diagnózis",
                visibility: false,
                formVisible: true,
                formRequired: true,
                formSize: 6,
                formType: "textarea",
            },
            {
                name: "koziliumKerdes",
                label: "Konzíliumi kérdés",
                visibility: false,
                formVisible: true,
                formSize: 6,
                formType: "textarea",
            },
            {
                name: "korelozmeny",
                label: "Kórelőzmény",
                visibility: false,
                formVisible: true,
                formSize: 6,
                formType: "textarea",
            },
            {
                name: "beutaloSzoveg",
                label: "Törzs",
                visibility: false,
                formVisible: true,
                formSize: 6,
                formType: "textarea",
            },
            {
                name: "betegErtesites",
                label: "Páciens értesítése eredményről",
                visibility: false,
                formVisible: true,
                formRequired: true,
                formSize: 3,
                formType: "checkbox",
            },
            {
                name: "orvosErtesites",
                label: "Orvos értesítése eredményről",
                visibility: false,
                formVisible: true,
                formRequired: true,
                formSize: 3,
                formType: "checkbox",
            },
        ],
        expenditureFormHeaderFields: [
            {
                name: "patientId",
                label: "Páciens azonosító",
                formVisible: false
            },
            {
                name: "eventId",
                label: "EseményKatalógus azonosító",
                formVisible: false
            },
            {
                name: "beutaloAzonosito",
                label: "Beutaló azonosítója",
                formSize: 4,
                formReadOnly: true,
                formVisible: true
            },
            {
                name: "rogzitesIdeje",
                label: "Rögzítés ideje",
                formType: "dateTime",
                formSize: 4,
                formReadOnly: true,
                formVisible: true
            },
            {
                name: "kiallitasDatuma",
                label: "Kiállítás dátuma",
                formType: "date",
                formSize: 4,
                formReadOnly: true,
                formVisible: true
            },
            {
                name: "ervenytessegDatuma",
                label: "Érvényesség dátuma",
                formType: "date",
                formSize: 4,
                formReadOnly: true,
                formVisible: true
            },
            {
                name: "beutaloTipus",
                label: "Típus",
                formSize: 4,
                formReadOnly: true,
                formVisible: true
            },
            {
                name: "beutaloAllapot",
                label: "Állapot",
                formSize: 4,
                formReadOnly: true,
                formVisible: true
            },
            {
                name: "beutaloOka",
                label: "Beutaló oka",
                formSize: 4,
                formReadOnly: true,
                formVisible: true
            },
            {
                name: "beutaloIntezmenyMegnevezes",
                label: "Beutaló intézmény",
                formSize: 4,
                formReadOnly: true,
                formVisible: true
            },
            {
                name: "beutaloSzervezetiEgysegMegnevezes",
                label: "Beutaló szervezeti egység",
                formSize: 4,
                formReadOnly: true,
                formVisible: true
            },
            {
                name: "ellatoIntezmenyMegnevezes",
                label: "Ellátó intézmény",
                formSize: 4,
                formReadOnly: true,
                formVisible: true
            },
            {
                name: "ellatoSzervezetiEgysegMegnevezes",
                label: "Ellátó szervezeti egység",
                formSize: 4,
                formReadOnly: true,
                formVisible: true
            },
            {
                name: "beutaloOrvosName",
                label: "Beutaló orvos",
                formSize: 4,
                formReadOnly: true,
                formVisible: true
            },
            {
                name: "betegsegFenallasIdeje",
                label: "Betegség fennálás ideje",
                formSize: 4,
                formReadOnly: true,
                formVisible: true
            },
            {
                name: "beutaloDiagnozis",
                label: "Beutaló diagnózis",
                formSize: 4,
                formReadOnly: true,
                formVisible: true
            },
            {
                name: "beutaloDiagnozisLeiras",
                label: "Diangózis leírás",
                formSize: 4,
                formReadOnly: true,
                formVisible: true
            },
            {
                name: "beutaloNaploSorszam",
                label: "Beutaló naplósorszáma",
                formSize: 4,
                formReadOnly: true,
                formVisible: true
            },
            {
                name: "beutaloSzoveg",
                label: "Szöveg",
                formSize: 4,
                formReadOnly: true,
                formVisible: true
            },
            {
                name: "korelozmeny",
                label: "Kórelőzmény",
                formSize: 4,
                formReadOnly: true,
                formVisible: true
            },
            {
                name: "koziliumKerdes",
                label: "Konzíliumi kérdés",
                formSize: 4,
                formReadOnly: true,
                formVisible: true
            },
            {
                name: "szolgaltatasTipus",
                label: "Szolgáltatás típus",
                formSize: 4,
                formReadOnly: true,
                formVisible: true
            }
        ]
    }
}
